import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy,Component,EventEmitter,Input,OnDestroy,Output,ViewChild } from '@angular/core';
import { FormControl,ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { BehaviorSubject,distinctUntilChanged,map,Observable,of,shareReplay,switchMap,withLatestFrom } from 'rxjs';

import { getCommissionById } from 'src/app/dave-data-module/State/selectors/commission.selector';
import { FileEntity } from '../../../../../dave-data-module/entities/file.entity';

import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MapMarker,MapMarkerFileDictionary } from '../../../../../dave-data-module/entities/event.entity';
import { FileDataService } from '../../../../../dave-data-module/services/file-data.service';
import { HttpService } from '../../../../../dave-data-module/services/http.service';
import { State } from '../../../../../dave-data-module/State';
import { getToken } from '../../../../../dave-data-module/State/selectors/base.selectors';
import { SelectSearchModule } from '../../../../../dave-utils-module/select-search/select-search.module';
import { isNotNullOrUndefined } from '../../../../../helper/helper';
import { LeafletWrapperComponent,markerColor } from '../../../../../leaflet-wrapper/leaflet-wrapper.component';
// ToDo: umbauen oder teile auslagern und in 2 Komponenten bauen, damit man eine PlanId übergeben kann um das vernünftig für die eventansicht nutzen zu können
@Component({
    selector: 'app-construction-diary-plans',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, LeafletWrapperComponent, MatFormFieldModule, SelectSearchModule, ReactiveFormsModule],
    templateUrl: './construction-diary-plans.component.html',
    styleUrls: ['./construction-diary-plans.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConstructionDiaryPlansComponent implements OnDestroy {
    private _commissionId = new BehaviorSubject<number>(null);
    @Input() set commissionId(value: number) {
        if (value !== this._commissionId.value) {
            this._commissionId.next(value);
        }
    }




     private _mapMarker: MapMarkerFileDictionary = {};
    @Input() set mapMarker(value: MapMarkerFileDictionary) {
        if (JSON.stringify(this._mapMarker) !== JSON.stringify(value)) {
            this._mapMarker = value;
            if (this.leafletWrapper?.LeafletInstance) {
                console.log("set map marker");
                this.leafletWrapper.clearMarkers();
                this.setEventsInit(this.leafletWrapper, this.planForm.value?.documentId);
            }
        }
    }


    @ViewChild(LeafletWrapperComponent) leafletWrapper: LeafletWrapperComponent;
    @Output() mapMarkerChange = new EventEmitter<MapMarkerFileDictionary>();
    @Output() screenshotTaken = new EventEmitter<Blob>();
    @Input() defaultMarker: Pick<MapMarker, 'color'> = {};

    private mapMarkerBuffer: {
        [key: number]: {
            _latlng: {
                lat: number;
                lng: number;
            };
            _icon: HTMLElement;
        }[];
    } = {};
    public planForm = new FormControl<{ documentId: number; documentName: string; optionLabel: string; imageUrl: string } | null>(null);
    public planFiles$: Observable<Array<FileEntity>>;
    public plans$: Observable<Array<{ documentId: number; documentName: string; optionLabel: string; imageUrl: string }>>;


    constructor(store: Store<State>, fileDataService: FileDataService, api: HttpService) {
        this.planFiles$ = this._commissionId.pipe(
            switchMap((id) => (id ? store.select(getCommissionById({ id })) : of(null))),
            map((commission) => commission?.PlanIds),
            distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
            switchMap((ids) => (ids.length ? fileDataService.GetFilesById(ids) : of([]))),
            map((files) => files.filter(isNotNullOrUndefined)),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.plans$ = this.planFiles$.pipe(
            withLatestFrom(store.select(getToken)),
            map(([files, token]) => files.map((f) => ({ documentId: f.Id, documentName: f.Name, optionLabel: f.Name, imageUrl: api.GetUrl(f.GetLastVersion().GetDownloadLink(token), 'file') }))),
            distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
    }

    ngOnDestroy(): void {
        this._commissionId.complete();
    }
    setEventsInit(leafletWrapperComponent: LeafletWrapperComponent, planId: number) {

        this._mapMarker[planId]?.forEach((m) =>
            leafletWrapperComponent.addMarker(
                Math.min(Math.max(m.top, 0), 1) ,
                Math.min(Math.max(m.left, 0), 1),
                { draggable: true },
                m.color ? m.color : undefined,
                null,
                m.tooltip ? m.tooltip : null
            )
        );

        if (leafletWrapperComponent.getMarker().length === 0 && this.defaultMarker) {
            leafletWrapperComponent.startAddMarkerMode({ draggable: true }, this.defaultMarker.color ? this.defaultMarker.color : undefined);
        }
        this.refreshMarker(leafletWrapperComponent, planId);
    }

    private refreshMarker(leafletWrapperComponent: LeafletWrapperComponent, planId: number) {
        const marker = leafletWrapperComponent.getMarker();
        this.mapMarkerBuffer[planId] = marker;

        if (marker?.length) {
            leafletWrapperComponent.stopAddMarkerMode();
        }
    }
    CompareByDocumentId(a: { documentId: number } | null, b: { documentId: number } | null) {
        return a?.documentId === b?.documentId;
    }

    private emitMapMarkerChange() {
        this.mapMarkerChange.emit(
            Object.keys(this.mapMarkerBuffer).reduce((prev, key) => {
                prev[key] = this.mapMarkerBuffer[+key].map<MapMarker>((m) => {
                    const colorMatch = m._icon?.className.match(LeafletWrapperComponent.MarkerCollerClassPrefix + '([^\\s]+)');
                    const width = this.leafletWrapper.imageWidth;
                    const height = this.leafletWrapper.imageHeight;
                    return {
                        top: m._latlng.lat / height,
                        left: m._latlng.lng / width,
                        color: colorMatch?.length > 1 ? (colorMatch[1] as markerColor) : null,
                    };
                });
                return prev;
            }, {} as MapMarkerFileDictionary),
        );
    }




    protected onMarkerMoved(leafletMap: LeafletWrapperComponent, documentId: number) {
        this.refreshMarker(leafletMap, documentId);
        this.emitMapMarkerChange();
    }

    protected onMarkerAdded(leafletMap: LeafletWrapperComponent, documentId: number) {
        this.refreshMarker(leafletMap, documentId);
        this.emitMapMarkerChange();
    }


    onScreenshotTaken(event: Blob) {
        this.screenshotTaken.emit(event)
    }
}
